




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Icon } from 'vant';
import VoteButton from '@/components/VoteButton.vue';

Vue.use(Icon);

@Component({
  components: {
    VoteButton,
  },
})
export default class ListItem extends Vue {
  @Prop() data!: any;
  @Prop({ default: false }) showZanBtn!: boolean;
  @Prop() index!: number;
}
